import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { QuicklinksTemplate } from "./quicklinks.templates";

export default {
    title: "Website/Partial Templates/Newsroom Blocks/Quicklinks Block",
    render: QuicklinksTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
